import { override, makeObservable } from 'mobx';

import { store } from '@store';
import { List } from '@store/abstract/List';

import { Allergy, AllergyParams } from './Allergy';
import { FieldStatus } from 'chaika-enums';

export interface AllergyFilterParams {
    isActive: boolean;
}

export class AllergyList extends List<Allergy, AllergyParams, AllergyFilterParams> {
    constructor(allergens: AllergyParams[]) {
        super();
        makeObservable(this);

        this.set(allergens || []);

        this.filterParams = { isActive: true };
    }

    @override
    public get ids(): string[] {
        return store.entry.isViewMode
            ? (Array.from(this.list.keys()) as string[])
            : this.serialize()
                  .filter(item => item.status !== FieldStatus.Deleted)
                  .map(item => item.id);
    }

    public serialize(): AllergyParams[] {
        const allergies: AllergyParams[] = [];

        this.list.forEach(allergy => {
            allergies.push(allergy.serialize());
        });

        return allergies;
    }

    public getSize(): number {
        return this.filteredValues.length;
    }

    protected create(params: AllergyParams): Allergy {
        return new Allergy(params);
    }

    protected filterValue(value: Allergy, filterParams: AllergyFilterParams): boolean {
        let res = true;

        if (filterParams.isActive) {
            res = value.status !== FieldStatus.Deleted;
        }

        return res;
    }
}
